export const createColumns = () => [
  {
    Header: 'Event',
    accessor: 'event.matchName',
    minWidth: 520,
    width: 520,
  },
  {
    Header: 'Category',
    accessor: 'category',
  },
  {
    Header: 'Subcategory',
    accessor: 'subCategory',
    minWidth: 200,
    width: 200,
  },
  {
    Header: 'Condition',
    accessor: 'triggerCondition',
  },
  {
    Header: 'Score',
    accessor: 'score',
  },
  {
    Header: 'Binary Winner',
    accessor: 'binaryWinner',
    minWidth: 140,
    width: 140,
  },
]
